import { ArrowRight } from "lucide-react";
import { Reveal } from "../components/Reveal";
import { scrollToId } from "../lib/scroll";

export const MakingCharges = () => (
  <section id="making-charges" data-testid="making-charges-section" className="py-20 md:py-28 bg-ivory">
    <div className="max-w-4xl mx-auto px-5 md:px-8 text-center">
      <Reveal>
        <p className="text-xs tracking-[0.25em] uppercase font-medium text-gold-muted mb-4">Making Charges</p>
        <h2 className="font-serif text-3xl sm:text-4xl lg:text-5xl text-royal-deep tracking-tight leading-tight">
          Beautiful Designs. <span className="italic text-gold-muted">Competitive Making Charges.</span>
        </h2>
        <p className="mt-6 text-base md:text-lg font-light text-charcoal/70 leading-relaxed max-w-2xl mx-auto">
          Making charges vary depending on the design and type of jewellery. Share the piece you have in mind and we will give you a clear, straightforward quote — no surprises.
        </p>
        <button
          data-testid="making-charges-enquire-button"
          onClick={() => scrollToId("enquiry")}
          className="mt-9 inline-flex items-center gap-2.5 px-8 py-3.5 border border-gold text-gold-muted text-sm tracking-[0.12em] uppercase font-medium rounded-sm hover:bg-gold hover:text-royal-deep transition-colors duration-300"
        >
          Enquire Now <ArrowRight size={14} strokeWidth={1.5} />
        </button>
      </Reveal>
    </div>
  </section>
);
